import React from 'react'
import './FloatingDev.css'
import { themeContext } from '../../Context'
import { useContext } from 'react'

function FloatingDev({img,txt1,txt2}) {
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode
  return (
    <div className="FloatingDev" >
        <img src={img}  alt="" />
        <span style={{color:darkMode? 'white' : ''}}>
           {txt1}
            <br />
            {txt2}
        </span>
    </div>
  )
}

export default FloatingDev